import * as React from 'react';
import clsx from 'clsx';

import { IconBadge } from './IconBadge';
import classes from './PredefinedIconBadge.module.scss';

interface Props {
  onClick?: () => void;
  title?: string;
  className?: string;
  isSmall?: boolean;
  count?: number;
}

export function ErrorIconBadge(props: Props) {
  return <IconBadge {...props} className={clsx(classes.error, props.className)} />;
}

export function WarningIconBadge(props: Props) {
  return <IconBadge {...props} className={clsx(classes.warning, props.className)} />;
}

export function SuccessIconBadge(props: Props) {
  return <IconBadge {...props} className={clsx(classes.success, props.className)} />;
}

export function AddIconBadge(props: Props) {
  return <IconBadge {...props} iconId='add' className={clsx(classes['add-icon'], props.className)} />;
}
